// extracted by mini-css-extract-plugin
export default {"fp-update-password-content-wrapper":"fp-update-password-content-wrapper-7378","back-to-sign-in-button":"back-to-sign-in-button-3f84"};